import React, { useEffect, useState } from "react";
import CssTransition from "../../../component/layout/css-transition";
import moment from "moment";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { addOverviewNotification } from "../../../redux/actions/overview";

// Component
import Table from "../../../component/table";

function NotificationModal({
  openNotificationModal,
  setOpenNotificationModal,
  handleNotificationData,
  notificationLoader,
}) {
  const { overviewNotificationData } = useSelector((state) => state.overview);
  const dispatch = useDispatch();

  const [allMappingIds, setAllMappingIds] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (openNotificationModal) {
      handleNotificationData();
    }
  }, [openNotificationModal]);

  const handleSelectAll = () => {
    if (allMappingIds.length === 0) {
      setAllMappingIds(
        overviewNotificationData.map(
          (item) => item.activity_assignment_mapping_id
        )
      );
    } else {
      setAllMappingIds([]);
    }
  };

  const handleSubmit = () => {
    setLoader(true);
    const request = {
      payload: {
        mapping_ids: allMappingIds,
      },
      onSuccess: () => {
        setLoader(false);
        setOpenNotificationModal(false);
        setAllMappingIds([]);
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={
                error?.message
                  ? error?.message
                  : "Something went wrong, please try again later."
              }
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(addOverviewNotification(request));
  };

  const assignedUser = (item) => {
    if (item.user_name) {
      return item.user_name;
    } else if (item.department_name) {
      return item.department_name;
    } else if (item.collaborator_name) {
      return item.collaborator_name;
    } else {
      return "";
    }
  };

  return (
    <>
      <CssTransition
        className="fixed -inset-4 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={openNotificationModal}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={openNotificationModal}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div className="bg-white max-w-3xl w-full h-[650px] rounded-xl shadow-lg flex flex-col">
          <div className="py-8 px-6 space-y-10">
            <h2 className="text-[#1E293B] font-semibold text-center">
              Notification
            </h2>
            <div className="w-full max-h-[425px]">
              <div className="max-h-[425px] max-w-full overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                <Table
                  heads={[
                    {
                      headName: (
                        <div className="flex items-center space-x-2">
                          <div class="flex items-center">
                            <input
                              id="customCheckbox"
                              type="checkbox"
                              className={`${
                                allMappingIds.length ===
                                  overviewNotificationData.length &&
                                allMappingIds.length > 0
                                  ? "block form-checkbox cursor-pointer"
                                  : "hidden"
                              }`}
                              checked={allMappingIds.length > 0}
                              onChange={(e) => {
                                handleSelectAll();
                              }}
                              disabled={overviewNotificationData.length === 0}
                            />
                            <label
                              for="customCheckbox"
                              class={`${
                                allMappingIds.length ===
                                  overviewNotificationData.length &&
                                allMappingIds.length > 0
                                  ? "hidden"
                                  : "block"
                              } form-checkbox flex items-center justify-center cursor-pointer ${
                                allMappingIds.length > 0
                                  ? "!bg-[--bg-color-500]"
                                  : "!bg-white"
                              }`}
                            >
                              <span
                                class={`text-white ${
                                  allMappingIds.length > 0 ? "block" : "hidden"
                                }`}
                              >
                                &ndash;
                              </span>
                            </label>
                          </div>

                          <span>Booking ID</span>
                        </div>
                      ),
                      isSort: false,
                      value: "booking_id",
                    },
                    {
                      headName: "To Do",
                      isSort: false,
                      value: "booking_id",
                    },
                    {
                      headName: "Assigned To",
                      isSort: false,
                      value: "assigned_to",
                    },
                    {
                      headName: "End Date",
                      isSort: false,
                      value: "estimated_time",
                    },
                  ]}
                  tClass="table-fixed w-full border-separate border-spacing-y-2"
                  hClass="text-[14px] leading-2 text-[#1E293B] !bg-[--bg-color-50] tracking-wide sticky top-0 text-left font-semibold"
                  bClass="text-[14px] !text-left"
                  thClass={`h-[40px] whitespace-nowrap text-left font-semibold first:rounded-l last:rounded-r max-w-10 sticky top-0 first:pl-4`}
                >
                  {notificationLoader ? (
                    <tr className="whitespace-nowrap h-[40px] text-center cursor-pointer">
                      <td colSpan={4}>
                        <div className="w-full flex justify-center items-center">
                          <span className="ml-2">
                            <svg
                              className="animate-spin w-5 h-45 fill-current shrink-0"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                            </svg>
                          </span>
                        </div>
                      </td>
                    </tr>
                  ) : overviewNotificationData.length > 0 ? (
                    overviewNotificationData.map((item) => (
                      <tr
                        className="whitespace-nowrap bg-[--bg-color-50] h-[40px] text-center cursor-pointer"
                        onClick={(e) => {
                          if (
                            allMappingIds.includes(
                              item.activity_assignment_mapping_id
                            )
                          ) {
                            setAllMappingIds(
                              allMappingIds.filter(
                                (ele) =>
                                  ele !== item.activity_assignment_mapping_id
                              )
                            );
                          } else {
                            console.log('row handle click inside else')
                            setAllMappingIds([
                              ...allMappingIds,
                              item.activity_assignment_mapping_id,
                            ]);
                          }
                        }}
                      >
                        <td
                          title={item.job_id}
                          className="text-left pl-4 rounded-tl rounded-bl"
                        >
                          <div className="max-w-full truncate space-x-2">
                            <input
                              className="form-checkbox cursor-pointer"
                              type="checkbox"
                              checked={allMappingIds.includes(
                                item.activity_assignment_mapping_id
                              )}
                              onChange={(e) => {
                                if (
                                  allMappingIds.includes(
                                    item.activity_assignment_mapping_id
                                  )
                                ) {
                                  setAllMappingIds(
                                    allMappingIds.filter(
                                      (ele) =>
                                        ele !==
                                        item.activity_assignment_mapping_id
                                    )
                                  );
                                } else {
                                  setAllMappingIds([
                                    ...allMappingIds,
                                    item.activity_assignment_mapping_id,
                                  ]);
                                }
                              }}
                            />
                            <span>{item.job_id}</span>
                          </div>
                        </td>
                        <td
                          title={item.activity_name}
                          className="text-left capitalize"
                        >
                          <div className="max-w-full truncate">
                            {item.activity_name}
                          </div>
                        </td>
                        <td className="text-left rounded-tr rounded-br">
                          {assignedUser(item)}
                        </td>
                        <td className="text-left rounded-tr rounded-br">
                          {moment(item.estimated_time).format(
                            "DD MMM, YYYY - hh:mm a"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="whitespace-nowrap bg-[--bg-color-50] h-[40px] text-center cursor-pointer">
                      <td colSpan={4}>No Data Found</td>
                    </tr>
                  )}
                </Table>
              </div>
            </div>
            <div className="flex justify-center items-center space-x-4">
              <button
                className="btn bg-[#fff] border-slate-200 hover:border-slate-300 text-slate-600 w-40"
                onClick={() => {
                  setOpenNotificationModal(false);
                  setAllMappingIds([]);
                }}
                disabled={loader}
              >
                Cancel
              </button>
              <button
                className="btn bg-[--bg-color-500] text-white w-40"
                onClick={() => handleSubmit()}
                disabled={loader}
              >
                {loader ? (
                  <svg
                    className="animate-spin w-5 h-45 fill-current shrink-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                  </svg>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default NotificationModal;
